import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../atoms/Icon'

const SIZE_FONT = {
  sm: '0.875rem',
  md: '1rem',
  lg: '1.25rem'
}

function SmartComponentDisplayName ({ title, icon, size, children }) {
  if (!title) return null

  const fontSize = SIZE_FONT[size] ?? SIZE_FONT.md

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
        {icon ? (
          <div style={{ display: 'flex', alignItems: 'center', fill: 'var(--color-primary-500)' }}>
            <Icon name={icon} customSize='24px' />
          </div>
        ) : null}
        <div style={{ fontSize, fontWeight: 600 }}>
          {title}
        </div>
      </div>
      {children ?? null}
    </div>
  )
}

SmartComponentDisplayName.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node
}

export default SmartComponentDisplayName
